module.exports = __webpack_public_path__ + "img/pdb.32a35c6d.png";